module.exports = __webpack_public_path__ + "344370bfdab946d90de6889f0f208c0c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/hoodie-blue-s.png
// module id = 1909
// module chunks = 0